import React from 'react';
import { Icon, Table } from 'semantic-ui-react';
import styled from 'styled-components';

import { BillingEstateSortColumn } from '../types';

type Props = {
  columnKey: BillingEstateSortColumn;
  activeSortBy: BillingEstateSortColumn;
  activeSortOrder: 'ASC' | 'DESC';
  onSort: (columnKey: BillingEstateSortColumn) => void;
  children: React.ReactNode;
};

const SortableHeaderCell = styled(Table.HeaderCell)`
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
`;

const HeaderContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const EstatesChargesSortableHeader: React.FC<Props> = ({
  columnKey,
  activeSortBy,
  activeSortOrder,
  onSort,
  children
}) => {
  const isActive = activeSortBy === columnKey;
  const iconName = isActive
    ? activeSortOrder === 'ASC'
      ? 'sort amount up'
      : 'sort amount down'
    : 'sort';

  return (
    <SortableHeaderCell
      onClick={() => onSort(columnKey)}
      aria-sort={
        isActive ? (activeSortOrder === 'ASC' ? 'ascending' : 'descending') : 'none'
      }
    >
      <HeaderContent>
        {children}
        <Icon name={iconName} style={{ margin: 0, opacity: isActive ? 1 : 0.45 }} />
      </HeaderContent>
    </SortableHeaderCell>
  );
};

export default EstatesChargesSortableHeader;
